/* eslint-disable */
declare global {
  interface Window {
    ChannelIO: Function
    ChannelIOInitialized: boolean
    attachEvent: Function
  }
}

class ChannelService {
  private static PLUGIN_KEY = '6182dd84-c259-45c6-9a5c-f2d1f9323ebc'

  static generateChannelIfNeeded() {
    const w = window

    // @ts-ignore
    const ch = function (...args) {
      ch.c(args)
    }

    if (w.ChannelIO) {
      return (window.console.error || window.console.log || function () {})('ChannelIO script included twice.')
    }
    // @ts-ignore
    ch.q = []
    // @ts-ignore
    ch.c = function (args) {
      ch.q.push(args)
    }
    w.ChannelIO = ch
    function l() {
      if (w.ChannelIOInitialized) {
        return
      }
      w.ChannelIOInitialized = true
      const s = document.createElement('script')
      s.type = 'text/javascript'
      s.async = true
      s.src = 'https://cdn.channel.io/plugin/ch-plugin-web.js'
      s.charset = 'UTF-8'
      const x = document.getElementsByTagName('script')[0]
      x?.parentNode?.insertBefore(s, x)
    }
    if (document.readyState === 'complete') {
      l()
    } else if (window.attachEvent) {
      window.attachEvent('onload', l)
    } else {
      window.addEventListener('DOMContentLoaded', l, false)
      window.addEventListener('load', l, false)
    }
    return true
  }

  static boot(settings: any) {
    ChannelService.generateChannelIfNeeded()
    window.ChannelIO('boot', settings)
  }

  static bootWithMember(memberId?: string | number | null) {
    ChannelService.boot({
      pluginKey: ChannelService.PLUGIN_KEY,
      memberId,
    })
  }

  static shutdown() {
    ChannelService.generateChannelIfNeeded()
    window.ChannelIO('shutdown')
  }
}

export default ChannelService
